import React, { useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import BlogPage from './pages/BlogPage';
import TeAmoPage from './pages/TeAmoPage';
import ValentinePage from './pages/ValentinePage';
import NotFoundPage from './pages/NotFoundPage';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import './styles.css';

const App: React.FC = () => {
  const [isDark, setIsDark] = useState(true);

  return (
    <div className={`min-h-screen transition-colors duration-300 ${isDark ? 'bg-gray-900 text-white' : 'bg-gray-50 text-gray-900'}`}>
      <BrowserRouter>
        <Navigation isDark={isDark} setIsDark={setIsDark} />
        
        <Routes>
          <Route path="/" element={<HomePage isDark={isDark} />} />
          <Route path="/blog" element={<BlogPage isDark={isDark} />} />
          <Route path="/te-amo" element={<TeAmoPage isDark={isDark} />} />
          <Route path="/valentine" element={<ValentinePage />} />
          <Route path="*" element={<NotFoundPage isDark={isDark} />} /> {/* Catch-all for invalid routes */}
        </Routes>

        <Footer isDark={isDark} />
      </BrowserRouter>
    </div>
  );
};

export default App;